// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectedActiveTab {
  height: 100%;
  background-color: white;
  color: #17A2B8;
  min-width: 13%;
  padding: 0.5%;
  font-size: 14px;
  border-bottom: 2px solid #17A2B8;
  text-align: center;
  font-weight: bold;
}

.selectedActiveTab:hover {
  background-color: #F3F3F7;
}

.tab {
  height: 100%;
  font-size: 12px;
  min-width: 13%;
  background-color: white;
  padding: 0.5%;
  text-align: center;
}

.tab:hover {
  background-color: #F3F3F7;
}

.condition {
  margin-bottom: 1%;
  display: flex;
  align-items: center;
}

.groups {
  background-color: white;
  border-radius: 10px 10px 10px 10px;
  margin-bottom: 1%;
}

.radio-and-inputboxes-group {
  padding: 0.5%;
  border: 3px solid #F3F3F7;
  border: 1px #17A0B4 solid;
  border-radius: 10px;
}

.predicate-filter {
  height: 7%;
  background-color: #17A2B8;
  color: white;
  display: flex;
  align-items: center;
  padding-left: 1%;
}

.header {
  width: 97%;
  font-size: 14px;
  font-weight: bold;
}

.predicate-rules {
  height: 83%;
  overflow: auto;
  padding: 0% 3% 0% 3%;
}

.predicate-rules-sub {
  min-height: 7%;
  padding-bottom: 1%;
  padding-top: 1%;
  background: white;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  position: sticky;
  top: 0;
  z-index: 100;
}

:host ::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled),
:host ::ng-deep .mdc-text-field--focused,
:host ::ng-deep .mdc-text-field--filled,
:host ::ng-deep .mat-mdc-form-field {
  background-color: #fff !important;
  --mdc-filled-text-field-focus-active-indicator-color: none !important;
}
:host ::ng-deep .mat-mdc-form-field-type-mat-input,
:host ::ng-deep .mat-mdc-form-field-type-mat-select {
  --mdc-filled-text-field-focus-label-text-color: black;
}
:host ::ng-deep .mat-mdc-form-field-type-mat-input .mat-mdc-form-field-subscript-wrapper,
:host ::ng-deep .mat-mdc-form-field-type-mat-select .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}
:host ::ng-deep .mat-mdc-form-field-infix {
  min-height: 40px !important;
  padding-top: 14px !important;
  padding-bottom: 6px !important;
}
:host ::ng-deep .mat-mdc-raised-button.mat-primary {
  background-color: #17A2B8;
  color: white;
}
:host ::ng-deep .mat-mdc-raised-button:disabled {
  color: grey;
}
:host ::ng-deep .mat-mdc-raised-button.mat-basic {
  background-color: white;
  color: #17A2B8;
  border: 1px #17A2B8 solid;
}
:host ::ng-deep .mat-mdc-radio-button .mdc-form-field {
  display: flex;
  align-items: flex-end;
}
:host ::ng-deep .mdc-label {
  font-size: 12px;
}
:host ::ng-deep .mdc-radio {
  transform: scale(0.85);
  /* Scales down the entire radio button */
}
:host ::ng-deep .matoutlinestyles.mat-mdc-form-field .mdc-text-field--outlined {
  padding: 3px 8px 3px 8px !important;
}
:host ::ng-deep .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-floating-label {
  top: 22px;
}`, "",{"version":3,"sources":["webpack://./src/app/rule-config-component/predicate-filter/predicate-filter.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EAEA,uBAAA;EACA,cAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,yBAAA;AAAJ;;AAGA;EACI,YAAA;EACA,eAAA;EACA,cAAA;EAEA,uBAAA;EAEA,aAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,yBAAA;AAFJ;;AAKA;EACI,iBAAA;EACA,aAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,uBAAA;EACA,kCAAA;EACA,iBAAA;AAFJ;;AAKA;EACI,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,UAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,UAAA;EACA,eAAA;EACA,iBAAA;AAFJ;;AAKA;EACI,WAAA;EACA,cAAA;EACA,oBAAA;AAFJ;;AAKA;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,MAAA;EACA,YAAA;AAFJ;;AAOI;;;;EAII,iCAAA;EACA,qEAAA;AAJR;AAOI;;EAEI,qDAAA;AALR;AAOQ;;EACI,wBAAA;AAJZ;AAQI;EACI,2BAAA;EACA,4BAAA;EACA,8BAAA;AANR;AASI;EACI,yBAAA;EACA,YAAA;AAPR;AAUI;EACI,WAAA;AARR;AAWI;EACI,uBAAA;EACA,cAAA;EACA,yBAAA;AATR;AAYI;EACI,aAAA;EACA,qBAAA;AAVR;AAaI;EACI,eAAA;AAXR;AAcI;EACI,sBAAA;EACA,wCAAA;AAZR;AAeI;EACI,mCAAA;AAbR;AAgBI;EACI,SAAA;AAdR","sourcesContent":[".selectedActiveTab {\r\n    height: 100%;\r\n    // margin: 0% 1% 0% 1%;\r\n    background-color: white;\r\n    color: #17A2B8;\r\n    min-width: 13%;\r\n    padding: 0.5%;\r\n    font-size: 14px;\r\n    border-bottom: 2px solid #17A2B8;\r\n    text-align: center;\r\n    font-weight: bold;\r\n}\r\n\r\n.selectedActiveTab:hover {\r\n    background-color: #F3F3F7;\r\n}\r\n\r\n.tab {\r\n    height: 100%;\r\n    font-size: 12px;\r\n    min-width: 13%;\r\n    // margin: 0% 1% 0% 1%;\r\n    background-color: white;\r\n    // border-radius: 8px 8px 8px 8px;\r\n    padding: 0.5%;\r\n    text-align: center;\r\n}\r\n\r\n.tab:hover {\r\n    background-color: #F3F3F7;\r\n}\r\n\r\n.condition {\r\n    margin-bottom: 1%;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.groups {\r\n    background-color: white;\r\n    border-radius: 10px 10px 10px 10px;\r\n    margin-bottom: 1%;\r\n}\r\n\r\n.radio-and-inputboxes-group {\r\n    padding: 0.5%;\r\n    border: 3px solid #F3F3F7;\r\n    border: 1px #17A0B4 solid;\r\n    border-radius: 10px;\r\n}\r\n\r\n.predicate-filter {\r\n    height: 7%;\r\n    background-color: #17A2B8;\r\n    color: white;\r\n    display: flex;\r\n    align-items: center;\r\n    padding-left: 1%;\r\n}\r\n\r\n.header {\r\n    width: 97%;\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n}\r\n\r\n.predicate-rules {\r\n    height: 83%;\r\n    overflow: auto;\r\n    padding: 0% 3% 0% 3%;\r\n}\r\n\r\n.predicate-rules-sub {\r\n    min-height: 7%;\r\n    padding-bottom: 1%;\r\n    padding-top: 1%;\r\n    background: white;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    justify-content: center;\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: 100;\r\n}\r\n\r\n:host ::ng-deep {\r\n\r\n    .mdc-text-field--filled:not(.mdc-text-field--disabled),\r\n    .mdc-text-field--focused,\r\n    .mdc-text-field--filled,\r\n    .mat-mdc-form-field {\r\n        background-color: #fff !important;\r\n        --mdc-filled-text-field-focus-active-indicator-color: none !important;\r\n    }\r\n\r\n    .mat-mdc-form-field-type-mat-input,\r\n    .mat-mdc-form-field-type-mat-select {\r\n        --mdc-filled-text-field-focus-label-text-color: black;\r\n\r\n        .mat-mdc-form-field-subscript-wrapper {\r\n            display: none !important;\r\n        }\r\n    }\r\n\r\n    .mat-mdc-form-field-infix {\r\n        min-height: 40px !important;\r\n        padding-top: 14px !important;\r\n        padding-bottom: 6px !important;\r\n    }\r\n\r\n    .mat-mdc-raised-button.mat-primary {\r\n        background-color: #17A2B8;\r\n        color: white;\r\n    }\r\n\r\n    .mat-mdc-raised-button:disabled {\r\n        color: grey;\r\n    }\r\n\r\n    .mat-mdc-raised-button.mat-basic {\r\n        background-color: white;\r\n        color: #17A2B8;\r\n        border: 1px #17A2B8 solid;\r\n    }\r\n\r\n    .mat-mdc-radio-button .mdc-form-field {\r\n        display: flex;\r\n        align-items: flex-end;\r\n    }\r\n\r\n    .mdc-label {\r\n        font-size: 12px;\r\n    }\r\n\r\n    .mdc-radio {\r\n        transform: scale(0.85);\r\n        /* Scales down the entire radio button */\r\n    }\r\n\r\n    .matoutlinestyles.mat-mdc-form-field .mdc-text-field--outlined {\r\n        padding: 3px 8px 3px 8px !important;\r\n    }\r\n\r\n    .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-floating-label {\r\n        top: 22px\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
